module.exports = __webpack_public_path__ + "img/b.25010d9f.jpg";